import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnowledgeBase } from 'src/app/models/knowledge-base';
import { KnowledgeService } from 'src/app/services/knowledge.service';

@Component({
  selector: 'app-knowledge-viewer',
  templateUrl: './knowledge-viewer.component.html',
  styleUrls: ['./knowledge-viewer.component.scss']
})
export class KnowledgeViewerComponent implements OnInit {

  public current_knowledge: KnowledgeBase = new KnowledgeBase();

  constructor(
    private route: ActivatedRoute,
    public _knowledgeService: KnowledgeService
  ) {

    let param = this.route.snapshot.paramMap.get('uid');

    this._knowledgeService.selectById(param)
      .subscribe((result) => {
        console.log(JSON.stringify(result))
        this.current_knowledge.id = result.id
        this.current_knowledge.name = result.name
        this.current_knowledge.html = result.html
      })

  }

  ngOnInit() {
  }

}
